// lib
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Navigate } from "react-big-calendar";
import TimeGrid from "react-big-calendar/lib/TimeGrid";
// src
import { formats } from "i18n/localizer";

const RANGE_LENGTH = 5;

const FiveDays = (props) => {
  const { date } = props;
  const range = FiveDays.range(date);
  return <TimeGrid {...props} range={range} />;
};

FiveDays.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

FiveDays.range = (date) => {
  const start = moment(date).startOf("week");
  const end = moment(start).add(RANGE_LENGTH - 1, "d");

  let current = start.toDate();
  const range = [];

  while (moment(current).isSameOrBefore(end)) {
    range.push(current);
    current = moment(current).add(1, "d").toDate();
  }

  return range;
};

FiveDays.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return moment(date).add(-7, "d").toDate();

    case Navigate.NEXT:
      return moment(date).add(7, "d").toDate();

    default:
      return date;
  }
};

FiveDays.title = (date) =>
  `${formats().dayRangeHeaderFormat({ start: date, end: moment(date).add(3, "day") })}`;

export default FiveDays;
